import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Logo from '../components/Logo.jsx';
import { config } from '../config.js';

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <Box component="footer" sx={{ pt: { xs: 6, md: 9 }, pb: 5, borderTop: '1px solid', borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 5 }}>
            <Logo />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2, maxWidth: 360 }}>
              Marketplace e gestão de fornecedores para condomínios, com integração ao WhatsApp e
              triagem de mensagens por IA.
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, md: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
              Plataforma
            </Typography>
            <Stack spacing={1}>
              <Link href="#como-funciona" color="text.secondary" variant="body2">
                Como funciona
              </Link>
              <Link href="#planos" color="text.secondary" variant="body2">
                Planos
              </Link>
              <Link href={config.appUrl} color="text.secondary" variant="body2">
                Entrar
              </Link>
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, md: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
              Desenvolvedores
            </Typography>
            <Stack spacing={1}>
              <Link href="https://developers.naporta.club/" color="text.secondary" variant="body2">
                Portal do desenvolvedor
              </Link>
              <Link href="/api-docs/index.html" color="text.secondary" variant="body2">
                Documentação da API
              </Link>
              <Link href="/api-docs/tutorial.html" color="text.secondary" variant="body2">
                Tutorial de integração
              </Link>
              <Link href="/api-docs/openapi.yaml" color="text.secondary" variant="body2">
                Especificação OpenAPI
              </Link>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
              Privacidade e contato
            </Typography>
            <Stack spacing={1}>
              <Link href={`mailto:${config.dpoEmail}`} color="text.secondary" variant="body2">
                Encarregado de dados (DPO): {config.dpoEmail}
              </Link>
              <Link href={`mailto:${config.contactEmail}`} color="text.secondary" variant="body2">
                {config.contactEmail}
              </Link>
              <Typography variant="body2" color="text.secondary">
                Titulares podem solicitar acesso, correção, portabilidade ou exclusão dos dados
                diretamente no aplicativo, em Perfil &gt; Privacidade.
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          sx={{ justifyContent: 'space-between', alignItems: { sm: 'center' } }}
        >
          <Typography variant="body2" color="text.secondary">
            &copy; {YEAR} NaPorta.club. Todos os direitos reservados.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {config.domain}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
